import { useNavigate } from "react-router-dom";
import React from "react";
import { Flex, Link, Button } from "@chakra-ui/react";
const textColor = "gray.300";

export default function NavbarDesktop() {
  const navigate = useNavigate();
  const handleGetInTouch = () => {
    navigate("/contact");
  };

  return (
    <>
      <Flex
        justifyContent={"space-between"}
        alignItems={"center"}
        width={"100%"}
        height={"8vh"}
        paddingY={10}
        paddingX={{ base: 5, lg: 10, xl: 20 }}
        top={0}
      >
        <Flex alignItems={"center"} gap={20}>
          <Link
            color={textColor}
            fontSize={"2xl"}
            textDecoration={"none"}
            _hover={{ textDecoration: "none" }}
            href="/"
          >
            Moiz
          </Link>
          <Flex gap={10}>
            <Link color={textColor} href="/">
              Home
            </Link>
            <Link color={textColor} href="/about">
              About
            </Link>
            <Link color={textColor} href="/work">
              Work
            </Link>
          </Flex>
        </Flex>
        <Flex gap={10}>
          <Button
            backgroundColor={"#34A9A7"}
            color={"gray.100"}
            background={"transparent"}
            _hover={{ background: "", transform: "scale(1.05)" }}
            animation={"all 0.3s ease-in-out"}
            onClick={handleGetInTouch}
            size={{ base: "sm", lg: "md" }}
          >
            Get in touch
          </Button>
        </Flex>
      </Flex>
    </>
  );
}

// export default NavbarDesktop;
